export const TIMEKEEPING_STATUSES = {
  APPROVED: 'approved',
  CONFLICT: 'conflict',
  PENDING: 'pending',
  DISPUTED: 'disputed',
  RESOLVED: 'resolved',
  FINALIZED: 'finalized',
  OVERTIME: 'overtime',
};

export const ACT_BTN_TEXT = {
  APPROVE: 'APPROVE',
  RESOLVE: 'RESOLVE',
  FINALIZE: 'FINALIZE',
};

export const FIFTEEN_MINS_IN_EPOCH = 900000;
